import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import { allocateSerialVisitOnCreate } from "../services/serialIndex";
import { toKey } from "../components/editModalFunctions";

type Handlers = {
  refreshList?: () => void;
};

export async function createTestItemViaPrompt(handlers: Handlers = {}): Promise<void> {
  const serial = prompt("Ange serienummer för testposten:", "");
  if (!serial) return;

  // Tilldela visit i serialIndex (och få display-format)
  const alloc = await allocateSerialVisitOnCreate("dev-test-item", serial);

  const productType = "test";
  const productTypeId = toKey(productType);
  const customer = "test";
  const customerId = "test";

  const now = serverTimestamp();

  await addDoc(collection(db, "itInventory"), {
    orderNumber: "1",
    customer,
    customerId,
    serial: alloc.displaySerial,
    serialBase: alloc.serialBaseKey,
    serialBaseKey: alloc.serialBaseKey,
    serialVisit: alloc.serialVisit,
    manufacturer: "test",
    model: "test",
    productType,
    productTypeId,
    warrantyStartDate: "9999-99-99",
    chargerIncluded: false,
    adapterYesNo: "",
    damageNotes: "",
    articleNumber: "test",
    photos: {},
    reuse: false,
    resold: false,
    scrap: false,
    isDraft: false,
    completed: false,
    createdAt: now,
    updatedAt: now,
    createdBy: "dev-helper",
    wizardStep: null,
    deletePending: false,
    auditLog: [{ action: "created-dev-helper", by: "dev-helper", at: new Date().toISOString() }],
  });

  if (handlers.refreshList) handlers.refreshList();
  alert("Testpost skapad.");
}
